import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import './Layout.css';
import VERSION from '../version';

const MONTHS = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];

export default function Layout({ children }) {
  const { profile, signOut } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  async function handleSignOut() {
    await signOut();
    navigate('/login');
  }

  const now = new Date();
  const greeting = now.getHours() < 12 ? 'Bom dia' : now.getHours() < 18 ? 'Boa tarde' : 'Boa noite';

  return (
    <div className="layout">
      <aside className={`sidebar ${menuOpen ? 'open' : ''} ${collapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          <span className="sidebar-logo-icon">₿</span>
          {!collapsed && <span className="sidebar-logo-text">Fincasa</span>}
          <button className="sidebar-collapse-btn" onClick={() => setCollapsed(c => !c)} title={collapsed ? 'Expandir menu' : 'Recolher menu'}>
            {collapsed ? '▶' : '◀'}
          </button>
        </div>

        <nav className="sidebar-nav">
          <Link to="/" className={`nav-item ${location.pathname === '/' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
            <span className="nav-icon">⊞</span>
            {!collapsed && <span>Dashboard</span>}
          </Link>

          <Link to="/tipos" className={`nav-item ${location.pathname === '/tipos' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
            <span className="nav-icon">📂</span>
            {!collapsed && <span>Tipos de Conta</span>}
          </Link>
          
          <Link to="/livro-caixa" className={`nav-item ${location.pathname === '/livro-caixa' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
            <span className="nav-icon">📖</span>
            {!collapsed && <span>Livro Caixa</span>}
          </Link>

          <Link to="/emprestimos" className={`nav-item ${location.pathname === '/emprestimos' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
            <span className="nav-icon">🏦</span>
            {!collapsed && <span>Empréstimos</span>}
          </Link>

          <Link to="/historico" className={`nav-item ${location.pathname === '/historico' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
            <span className="nav-icon">📋</span>
            {!collapsed && <span>Atividades</span>}
          </Link>

          {profile?.is_super_admin && (
            <Link to="/super" className={`nav-item ${location.pathname === '/super' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
              <span className="nav-icon">⚡</span>
              {!collapsed && <span>Super Admin</span>}
            </Link>
          )}

          <Link to="/ajuda" className={`nav-item ${location.pathname === '/ajuda' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
            <span className="nav-icon">❓</span>
            {!collapsed && <span>Ajuda</span>}
          </Link>

          {profile?.role === 'admin' && (
            <Link to="/admin" className={`nav-item ${location.pathname === '/admin' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
              <span className="nav-icon">⚙</span>
              {!collapsed && <span>Administração</span>}
            </Link>
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">{profile?.name?.[0]?.toUpperCase() || '?'}</div>
            {!collapsed && <div>
              <div className="user-name">{profile?.name}</div>
              <div className="user-role">{profile?.role === 'admin' ? 'Administrador' : 'Usuário'}</div>
            </div>}
          </div>
          {!collapsed && <div className="sidebar-version">v{VERSION}</div>}
          {!collapsed && <button className="btn btn-ghost btn-sm logout-btn" onClick={handleSignOut}>
            Sair
          </button>}
        </div>
      </aside>

      {menuOpen && <div className="overlay" onClick={() => setMenuOpen(false)} />}

      <main className="main-content">
        <header className="topbar">
          <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>☰</button>
          <div className="topbar-greeting">
            <span className="greeting-text">{greeting}, <strong>{profile?.name?.split(' ')[0]}</strong></span>
            <span className="topbar-date text-muted text-sm">{MONTHS[now.getMonth()]} {now.getFullYear()}</span>
          </div>
          <button className="theme-toggle" onClick={toggleTheme} title={theme === 'dark' ? 'Modo claro' : 'Modo escuro'}>
            {theme === 'dark' ? '☀️' : '🌙'}
          </button>
        </header>
        <div className="page-content">
          {children}
        </div>
      </main>
    </div>
  );
}
